/**
 * Copyright 2024 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { SelectButton, SelectButtonProps } from "@nordcloud/gnui";

export function SelectButtonStyled(props: SelectButtonProps) {
  return <SelectButton {...props} style={{ transition: "none" }} />;
}
